import { ValidationHelper } from '../ValidationHelper';

export function validateSSN(value: string): string | boolean {
    if (value != null && value.length >= 12) {

        var isValid = ValidationHelper.Mod10CheckSocialSecurityOrganizationNumber(value);
        if (!isValid) {
            return false;
        }
    }
    return true;
}

export function validateDateOfBirth(value: string, formatDateOfBirth: string): string | boolean {
    if (value == '' || value == null) {
        return false;
    }

    var rxDatePattern = /^\d{4}\d{2}\d{2}$/; //Declare Regex ����MMDD

    let formatdate = formatDateOfBirth;

    if (formatdate == null || formatdate == '')
        formatdate = '����MMDD';

    switch (formatdate.length) {
        case 4: // '����'
            rxDatePattern = /^\d{4}$|^\d{4}\d{2}$|^\d{4}\d{2}\d{2}$|^\d{4}\d{2}\d{2}-\d{4}$|^\d{4}\d{2}\d{2}\d{4}$/; //���� or ����MM or ����MMDD or ����MMDD-XXXX or ����MMDDXXXX
            break;
        case 6: // '����MM'
            rxDatePattern = /^\d{4}\d{2}$|^\d{4}\d{2}\d{2}$|^\d{4}\d{2}\d{2}-\d{4}$|^\d{4}\d{2}\d{2}\d{4}$/; //����MM or ����MMDD or ����MMDD-XXXX or ����MMDDXXXX
            break;
        case 8: // '����MMDD'
            rxDatePattern = /^\d{4}\d{2}\d{2}$|^\d{4}\d{2}\d{2}-\d{4}$|^\d{4}\d{2}\d{2}\d{4}$/; //����MMDD or ����MMDD-XXXX or ����MMDDXXXX
            break;
        default:
            rxDatePattern = /^\d{4}\d{2}\d{2}-\d{4}$/; // ����MMDD-XXXX  should never happen this is not an option when ssn is not mandatory
    }

    var dtArray = value.match(rxDatePattern); // is format OK?

    if (dtArray == null) {
        return false;
    }

    let dtYear = 0;
    let dtMonth = 1; //initiate to 1 so it will pass the below if else if only year is allowed
    let dtDay = 1;   //initiate to 1 so it will pass the below if else if only year and/or month is allowed

    dtYear = parseInt(value.substr(0, 4));

    if (value.length > 6)
        dtMonth = parseInt(value.substr(4, 2));
    if (value.length > 8)
        dtDay = parseInt(value.substr(6, 2));

    if (dtMonth < 1 || dtMonth > 12) {
        return false;
    } else if (dtDay < 1 || dtDay > 31) {
        return false;
    } else if ((dtMonth == 4 || dtMonth == 6 || dtMonth == 9 || dtMonth == 11) && dtDay == 31) {
        return false;
    } else if (dtMonth == 2) {
        var isleap = (dtYear % 4 == 0 && (dtYear % 100 != 0 || dtYear % 400 == 0));
        if (dtDay > 29 || (dtDay == 29 && !isleap)) {
            return false;
        }
    }
    return true;

}

export function validateSSNDate(ssn: string): boolean {
    if (!ssn) {
        return true;
    }
    //Extract the substrings from the ssn if they exist
    const yearStr = ssn.substring(0, 4);
    const monthStr = ssn.length >= 6 ? ssn.substring(4, 6) : null;
    const dayStr = ssn.length >= 8 ? ssn.substring(6, 8) : null;


    //Month or day could be null
    const year = parseInt(yearStr, 10);
    const month = monthStr ? parseInt(monthStr, 10) : null;
    const day = dayStr ? parseInt(dayStr, 10) : null;

    const currentYear = new Date().getFullYear();
    //Im assuming no one is older than 150 years
    if (year < (currentYear - 150) || year > currentYear) {
        return false;
    }
    //Check month is within span
    if (month !== null && (month < 1 || month > 12)) {
        return false;
    }
    if (day !== null) {
        //Extra month check since we're using it here
        if (month === null) {
            return false;
        } 
        const daysInMonth = new Date(year, month, 0).getDate();
        if (day < 1 || day > daysInMonth) {
            return false;
        }

    }
    return true;
} 